var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Terms.less');

module.exports = Section.extend({

    el: '.Terms',


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Terms/Terms.js
// module id = 301
// module chunks = 0